import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------------
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

// ------------------ CONSULTAS A LA API---------------------------------
import { RequisasPorIdCurrencyIdVendor } from "../../../../../API/Compras/Requisas/PurchaseRequest";

const RequisasOverlayPanel = ({
  setNuevaFila,
  selectedPcs,
  setSelectedPCs,
  IdProveedor, IdMoneda ,
  habilitar,
  Functions
}) => {
  const lo = useRef(null);
  const toast = useRef();

  const { userAuth } = useContext(AuthContext);

  const [requisasAuth, setRequisasAuth] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);

  const openOver = (e) => {
    if (IdProveedor && IdMoneda) {
      setShouldFetch(true); // Permitir que useEffect ejecute fetchData
      lo.current.toggle(e);
    } else {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione un proveedor y una moneda"
      );
    }
  };

  const fetchData = async () => {
    if (IdProveedor && IdMoneda) {
      setLoading(true);
      try {
        const response = await RequisasPorIdCurrencyIdVendor(
          IdMoneda,
          IdProveedor
        );
        setRequisasAuth(response);
      } catch (error) {
        toastShow(toast, "error", "Error", "Error al obtener los datos");
      }
      setLoading(false);
    }
  };

  const AsignarInformacion = () => {
    if (Functions.verificarCamposEncabezado()) {
      lo.current.hide();
    }else{
      setNuevaFila(selectedPcs);
      lo.current.hide();
      setSelectedPCs([])
    }
  };

  const columns = [
    {
      // ID
      field: "IdPurcharesRequestDetail",
      header: "ID Detalle",
      headerEn: "ID Detail",
      className: "Xsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
    },
    {
        // REQUISA
        field: 'PurchaseRequest',
        header: 'Requisa',
        className: "small",
        sortable: true,
        filter: true
    },
    {
        // PRODUCTO
        field: 'NombreProducto',
        header: 'Producto',
        className: "large",
        sortable: true,
        filter: true
    },
    {
        // CATEGORIA
        field: 'NombreCategoria',
        header: 'Categoria',
        className: "medium",
        sortable: true,
        filter: true
    },
    {
        // TIPO
        field: 'Type',
        header: 'Tipo',
        className: "small",
        sortable: true,
        filter: true
    },
    {
        // PRECIO
        field: 'Price',
        header: 'Precio',
        Format: 'Currency',
        className: "small",
        sortable: true,
        filter: true
    },
    {
        // MONEDA
        field: 'CurrencySymbol',
        header: 'Moneda',
        className: "small",
        Format: 'Center',
        sortable: true,
        filter: true
    },
    {
        // CANTIDAD
        field: 'Quantity',
        header: 'Cantidad',
        Format: 'Currency',
        className: "small",
        sortable: true,
        filter: true
    },
    {
        // UNIDAD
        field: 'UnitSimbol',
        header: 'Unidad',
        className: "small",
        Format: 'Center',
        sortable: true,
        filter: true
    },
    {
        // SUBTOTAL
        field: 'SubTotal',
        header: 'SubTotal',
        className: "small",
        Format: 'Currency',
        sortable: true,
        filter: true
    },
    {
        // DESCUENTO
        field: 'Discount',
        header: 'Descuento',
        className: "small",
        Format: 'Currency',
        sortable: true,
        filter: true
    },
    {
        // TOTAL
        field: 'Total',
        header: 'Total',
        className: "small",
        Format: 'Currency',
        sortable: true,
        filter: true
    },

  ]

  useEffect(() => {
    if (shouldFetch) {
      fetchData();
      setShouldFetch(false); // Resetear el estado para evitar llamadas adicionales no deseadas
    }
  }, [shouldFetch]);

  useEffect(() => {
    if (IdProveedor || IdMoneda) {
      fetchData();
    }
  }, [IdProveedor, IdMoneda]);


  const table = {
    Data: requisasAuth,
    selected: selectedPcs,
    setSelected: setSelectedPCs,
    Columns: columns,
    loading: loading,

  };


  return (
    <div>
      <Toast ref={toast} />
      <div className="p-inputgroup mx-2" style={{ width: 220 }}>
        <Button
          label="Agregar Requisas"
          onClick={() => AsignarInformacion()}
          disabled={!selectedPcs || selectedPcs?.length === 0}
        />
        <Button
          icon="pi pi-angle-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => openOver(e)}
          disabled={!habilitar}
        />
      </div>
      <OverlayPanel ref={lo} showCloseIcon dismissable={false}>
        <Loader querySelector="FacturasPagoCliente" />
        <div style={{ height: "55vh", width: "80vw" }} id="FacturasPagoCliente">
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default RequisasOverlayPanel;
